<template>
    <div class="content-container-white">
        <ModuleHeader title="Projekte">
            <div><ul class="horizontal-list">
                <li>
                    <router-link class="icon-link" :to="{name: 'ProjectAdd'}"><font-awesome-icon icon="plus" class="icon"/> Neu</router-link>
                </li>
            </ul></div>
        </ModuleHeader>

        <div class="container-fluid">
            <div class="loading" v-if="loading && !error">
            </div>

            <div v-if="error" class="error">
                {{ error }}
            </div>

            <div v-if="projects">

                    <v-client-table :data="projects" :columns="columns" :options="options">

                        <router-link slot="action" slot-scope="props" class="i-con-h-a" :to="{name: 'ProjectEdit', params: {slug: props.row.slug}}"><i class="i-con i-con-edit"></i></router-link>

                        <vuetable-pagination-info
                                info-template="Spanish text {from} to {to} of {total} records"
                        ></vuetable-pagination-info>
                    </v-client-table>

            </div>
        </div>
    </div>
</template>

<script>
    import ModuleHeader from "components/util/ModuleHeader";
    import firestore from "firedb/init";

    export default {
        name: "ProjectDashboard",
        components: {ModuleHeader},
        data: () => {
            return {
                loading: true,
                error: null,
                projects: [],

                columns: ['name', 'status', 'customer_name', 'action'],

                options: {
                    skin: 'table table-hover data-table',
                    filterable: false
                },
            }
        },

        created () {
            // fetch the data when the view is created and the data is
            // already being observed
            this.fetchData()
        },

        methods: {
            fetchData() {
                this.error = this.projects = null;
                this.loading = true;

                firestore.collection('project').get()
                    .then(snapshot => {

                        this.projects = [];
                        snapshot.forEach(doc => {
                            let project = doc.data();
                            project.id = doc.id;

                            this.projects.push(project);
                        });

                        this.loading = false;
                    })
                    .catch((e) => {
                        if (e.code === 'permission-denied') {
                            this.error = 'Berechtigungen fehlen';
                        } else {
                            this.error = 'Unerwarteter Fehler';
                        }
                    });
            },
        }
    }
</script>

<style scoped lang="scss">

</style>